import Header from "../components/Layout/Header.jsx";
import Footer from "../components/Layout/Footer.jsx";
import CartDrawer from "../components/Cart/CartDrawer.jsx";
import { Link } from 'react-router-dom'

export default function HowItWorks() {
  return (
    <div className="how-it-works-page">
      <Header />

      <main className="home-main">
        <section className="intro-section">
          <div className="section-inner narrow">
            <p className="section-label">How It Works</p>
            <h1>Pick a card. <br/> Scan the QR. <br/> Watch the surprise appear.</h1>
            <p>
              WildCard combines a traditional greeting card with a personalized AR experience
              that opens instantly from a phone camera — no app or login required.
            </p>
            <p>
              If you'd rather not send your WildCard digitally, print it! 
              We can instantly generate a printable file with your customized order.
              <br/>
              Use your printer at home to keep that classic touch of recieving a card in the mail.
              Or, order invitations and print as many copies of the card as you'd like!
            </p>
          </div>
        </section>

        <section className="info-grid-section">
          <div className="section-inner">
            <h2>YOU:</h2>
            <div className="info-grid">
                
              <div className="info-card">
                
                <h3>1. Choose a Card</h3>
                <p>Pick a design from the online store for a birthday, holiday, celebration, or special moment.</p>
              </div>

              <div className="info-card">
                <h3>2. Personalize It</h3>
                <p>Add the recipient’s name. Some cards may also allow you to use a themed filter and create a custom video message.</p>
              </div>

              <div className="info-card">
                <h3>3. Checkout</h3>
                <p>Complete your order securely. Your personalized card and QR code are generated within seconds after checkout.</p>
              </div>
              </div>
              <h2>THEM:</h2>
               <div className="info-grid">
              <div className="info-card">
                <h3>4. Receive the Card</h3>
                <p>Your card can be delivered digitally or prepared as a printable postcard. You decide!</p>
              </div>

              <div className="info-card">
                <h3>5. Scan the QR Code</h3>
                <p>The recipient scans the QR code with their phone camera to open the AR experience.</p>
              </div>

              <div className="info-card">
                <h3>6. Enjoy the Surprise</h3>
                <p>Just like scanning the QR for a resturuant menu, the personalized AR message appears instantly on the user's browser.</p>
              </div>
            </div>
          </div>
        </section>
        {/* CTA */}
        <section className="bottom-cta">
          <div className="section-inner narrow center">
            <h2>Ready to send something people will actually remember?</h2>
            <p>
              Shop personalized AR greeting cards and create a surprise worth scanning.
            </p>
            <Link to="/shop" className="hero-btn primary">
              Shop Now
            </Link>
          </div>
        </section>
      </main>

      <CartDrawer />
      <Footer />
    </div>
  );
}